export const SEARCH_BOOKINGS = "SEARCH_BOOKINGS";
export const SEARCH_BOOKINGS_SUCCESS = "SEARCH_BOOKINGS_SUCCESS";
export const SEARCH_BOOKINGS_FAILED = "SEARCH_BOOKINGS_FAILED";

export const CANCEL_BOOKINGS = "CANCEL_BOOKINGS";
export const CANCEL_BOOKINGS_SUCCESS = "CANCEL_BOOKINGS_SUCCESS";
export const CANCEL_BOOKINGS_FAILED = "CANCEL_BOOKINGS_FAILED";

export const SET_REMINDER = "SET_REMINDER";
export const SET_REMINDER_SUCCESS = "SET_REMINDER_SUCCESS";
export const SET_REMINDER_FAILED = "SET_REMINDER_FAILED";

export const SEND_CHECKIN_EMAIL = "SEND_CHECKIN_EMAIL";
export const SEND_CHECKIN_EMAIL_SUCCESS = "SEND_CHECKIN_EMAIL_SUCCESS";
export const SEND_CHECKIN_EMAIL_FAILED = "SEND_CHECKIN_EMAIL_FAILED";

export const SEND_CHECKOUT_EMAIL = "SEND_CHECKOUT_EMAIL";
export const SEND_CHECKOUT_EMAIL_SUCCESS = "SEND_CHECKOUT_EMAIL_SUCCESS";
export const SEND_CHECKOUT_EMAIL_FAILED = "SEND_CHECKOUT_EMAIL_FAILED";

export const FETCH_BOOKING_DETAILS = "FETCH_BOOKING_DETAILS";
export const FETCH_BOOKING_DETAILS_SUCCESS = "FETCH_BOOKING_DETAILS_SUCCESS";
export const FETCH_BOOKING_DETAILS_FAILED = "FETCH_BOOKING_DETAILS_FAILED";

export const SELECT_BOOKING = "SELECT_BOOKING";

export const fetchBookingDetails = (id) => ({
  type:FETCH_BOOKING_DETAILS,
  id
})

export const searchBookings = (payload, token) => ({
  type: SEARCH_BOOKINGS,
  payload,
  token,
});

export const selectBooking = (payload) => ({
  type: SELECT_BOOKING,
  payload,
});

export const cancelBooking = (payload, token) => ({
  type: CANCEL_BOOKINGS,
  payload,
  token,
});
export const setReminder = (payload, token) => ({
  type: SET_REMINDER,
  payload,
});
export const sendCheckinEmail = (payload, token) => ({
  type: SEND_CHECKIN_EMAIL,
  payload,
});
export const sendCheckoutEmail = (payload, token) => ({
  type: SEND_CHECKOUT_EMAIL,
  payload,
});
